import { State } from "@/types/frontend";

export default class OidcState {
    private readonly state: State | null = null;

    constructor() {
        const state = new URLSearchParams(window.location.search).get("state");
        this.state = state ? (JSON.parse(atob(state)) as State) : null;
    }

    public get() {
        return this.state;
    }

    public exists() {
        return this.state !== null;
    }

    public verificationId() {
        return this.state?.verification_id;
    }

    public flag() {
        return this.state?.flag;
    }

    public complete() {
        return this.state?.flag === "complete";
    }

    public hasError() {
        return this.state?.flag === "error";
    }

    public message() {
        return this.state?.message || "";
    }
}
